import { isProject } from 'app/routes/routes.js';
import { isCurrentProject } from 'app/store/projects/selectors.js';
import { doLoadCurrentProject } from 'app/store/projects/actions.js';

export const handleCollaboratorActions = (dispatch, getState, response) => {
    const { responseName, payload, status } = response;

    if (status === 'Failed') {
        return;
    }

    switch (responseName) {
        case 'TransformationNodeUpdated':
        case 'TransformationNodeCreated':
        case 'TableDeploymentSucceeded':
        case 'ViewDeploymentSucceeded':
        case 'DeployedTransformationDeleted':
        case 'DataSourceImported':
        case 'ViewDeleted': {
            const state = getState();
            const { spaceUid } = payload?.viewRef ?? {};

            if (isProject() && isCurrentProject(spaceUid, state)) {
                dispatch(doLoadCurrentProject());
            }

            break;
        }
        default:
            break;
    }
};
